import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  type: 'Audience Analysis',
  currentYear: '',
  currentQuarter: '',
  selectedYear: '',
  selectedQuarter: '',
  compareSelectedYear: '',
  compareSelectedQuarter: '',
  audienceAnalysisRange: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null
  },
  compareAudienceAnalysisRange: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null
  },
}

const audienceAnalysisSlice = createSlice({
  name: 'audienceAnalysis',
  initialState,
  reducers: {
    setCurrentQuarter: (state, action) => {
      return { ...state, currentQuarter: action.payload }
    },
    setCurrentYear: (state, action) => {
      return { ...state, currentYear: action.payload }
    },
    setSelectedQuarter: (state, action) => {
      return { ...state, selectedQuarter: action.payload }
    },
    setSelectedYear: (state, action) => {
      return { ...state, selectedYear: action.payload }
    },
    setCompareSelectedYear: (state, action) => {
      return { ...state, compareSelectedYear: action.payload}
    },
    setCompareSelectedQuarter: (state, action) => {
      return { ...state, compareSelectedQuarter: action.payload }
    },
    setAudienceAnalysisRange: (state, action) => {
      return { ...state, audienceAnalysisRange: action.payload }
    },
    setCompareAudienceAnalysisRange: (state, action) => {
      return { ...state, compareAudienceAnalysisRange: action.payload }
    },
  }
})

export const audienceAnalysisActions = audienceAnalysisSlice.actions

export default audienceAnalysisSlice.reducer
